import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DconConfigAPI } from './config';
import { DataService } from './data.service';
import { CommonServicesService } from '../services/common-services.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from "ngx-spinner";
import { DconCredentialsComponent } from './dcon-credentials.component';

@Component({
    selector: 'dcon-auth',
    template: `<dcon-credentials></dcon-credentials>`,
    providers: [DconCredentialsComponent]
})

export class DconAuthComponent implements OnInit {
    public authProjectID: any;
    loggedUser: string;
    public data: any;
    public projectName: any;
    isUserAccess: boolean = true;
    userPermissionBaseUrl: string;
    public currentMessage: any;
    tokenValue: any;
    counter: number = 0;

    constructor(public _httpService: CommonServicesService,
        public dialog: MatDialog,
        private _data: DataService, private SpinnerService: NgxSpinnerService, public dconData: DconCredentialsComponent) { }
    ngOnInit() {
        this.fetchApi();
        this.loggedUser = this._data.loggedUserId.substr(0, this._data.loggedUserId.length - 13);
    }

    fetchApi() {
        this.SpinnerService.show();
        console.log("1. first api - dcon-auth component");
        this._httpService.callDconSecurityCredApi().subscribe((response) => {
            this.data = response;
            this._data.keyVaultAuthData = 'Basic ' + btoa(this.data.body.username + ':' + this.data.body.passkey);
            this.SpinnerService.hide();
            this.getProjectInfo();
        });
    }

    getProjectInfo() {
        this.SpinnerService.show();
        const options = {
            headers: {
                Authorization: this._data.keyVaultAuthData,
                user: this.loggedUser,
                app: DconConfigAPI.APPLICATION
            }
        };
        // this.userPermissionBaseUrl = DconConfigAPI.SW_ORDS_BASE_URL;
        console.log("2. projects list api - dcon-auth component");
        let secret_name=DconConfigAPI.projectInfo;
        this._httpService.callUserPermissionApi(secret_name).subscribe((res: any) => {
            let projectInfo= JSON.parse(atob(res?.body?.username))
            console.log('projectInfo',projectInfo)
            this.authProjectID = projectInfo;
            this._data.authProjectID.next(projectInfo);
            if (projectInfo.items.length === 0) {
                this.isUserAccess = false;
                this.projectName = 'No_Project';
                console.log(' callUserPermissionApi No User Access', this.isUserAccess);
            } else {
                if (projectInfo.items.length === 1) {
                    if (projectInfo.items[0].projectid == null) {
                        this.projectName = 'Maintainance';
                        this.isUserAccess = false;
                    }
                }
            }
            // this._data.apiCallInProgress = false;
            // document.getElementById("overlay").style.display = "none";
        },
            error => {
                this._data.apiCallInProgress = false;
                document.getElementById("overlay").style.display = "none";
                alert(error.message);
            });
    }

    getUIPathCreds(id) {
        console.log("----------calling uipath creds --------  dcon-auth component");
        this.dconData.getUIPathCreds(id);
    }
}

